/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ResolveIntegrationEventResponseData } from './ResolveIntegrationEventResponseData';
import {
    ResolveIntegrationEventResponseDataFromJSON,
    ResolveIntegrationEventResponseDataFromJSONTyped,
    ResolveIntegrationEventResponseDataToJSON,
    ResolveIntegrationEventResponseDataToJSONTyped,
} from './ResolveIntegrationEventResponseData';

/**
 * 
 * @export
 * @interface ResolveIntegrationEventResponse
 */
export interface ResolveIntegrationEventResponse {
    /**
     * 
     */
    data?: ResolveIntegrationEventResponseData;
}

/**
 * Check if a given object implements the ResolveIntegrationEventResponse interface.
 */
export function instanceOfResolveIntegrationEventResponse(value: object): value is ResolveIntegrationEventResponse {
    return true;
}

export function ResolveIntegrationEventResponseFromJSON(json: any): ResolveIntegrationEventResponse {
    return ResolveIntegrationEventResponseFromJSONTyped(json, false);
}

export function ResolveIntegrationEventResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResolveIntegrationEventResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : ResolveIntegrationEventResponseDataFromJSON(json['data']),
    };
}

export function ResolveIntegrationEventResponseToJSON(json: any): ResolveIntegrationEventResponse {
    return ResolveIntegrationEventResponseToJSONTyped(json, false);
}

export function ResolveIntegrationEventResponseToJSONTyped(value?: ResolveIntegrationEventResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ResolveIntegrationEventResponseDataToJSON(value['data']),
    };
}

